import { IResolver, IServiceInterfaces } from '@mse-reg/clients';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppThunkConfig } from '.';
import { addExceptionNotification } from '../modules/notification.slice';

export const createAppThunk = <Returned, ThunkArg = void, Dependencies = void>(
  typePrefix: string,
  thunkFunction: (
    arg?: ThunkArg,
    deps?: Dependencies,
    dispatch?: AppThunkConfig['dispatch'],
    getState?: () => AppThunkConfig['state'],
    extra?: AppThunkConfig['extra'],
    rejectWithValue?: (value: any) => any,
  ) => Promise<Returned> | Returned,
  dependencies?: (resolver: IResolver<IServiceInterfaces>) => Dependencies,
  onError?:
    | ((
        error: unknown,
        arg?: ThunkArg,
        dispatch?: AppThunkConfig['dispatch'],
        getState?: () => AppThunkConfig['state'],
      ) => void | string)
    | string,
) =>
  createAsyncThunk<Returned, ThunkArg, AppThunkConfig>(typePrefix, async (arg, thunkAPI) => {
    try {
      return await thunkFunction(
        arg,
        dependencies ? dependencies(thunkAPI.extra.resolver) : ({} as Dependencies),
        thunkAPI.dispatch,
        thunkAPI.getState,
        thunkAPI.extra,
        thunkAPI.rejectWithValue,
      );
    } catch (error: unknown) {
      if (onError) {
        if (typeof onError === 'string') {
          thunkAPI.dispatch(addExceptionNotification({ message: onError, level: 'error' }));
          return;
        }
        const result = onError(error, arg, thunkAPI.dispatch, thunkAPI.getState);
        if (result) {
          thunkAPI.dispatch(addExceptionNotification({ message: result, level: 'error' }));
          return;
        }
        return;
      }
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
      return thunkAPI.rejectWithValue(errorMessage);
    }
  });
